class PhrasesService {
    constructor() {
        this.phrases = {};

        if (!window._data || !window._data.phrases) {
            return;
        }

        for (var i = 0; i < window._data.phrases.length; i++) {
            var phrase = window._data.phrases[i];
            this.phrases[phrase.T] = phrase.V;
        }
    }

    getPhrase(title) {
        if (!this.phrases[title]) {
            return title;
        }

        return this.phrases[title];
    }
}

PhrasesService.shared = new PhrasesService();
Vue.component('contact', {
        props: {},
        data: function () {
            return {
                userData: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    message: ''
                },
                settings: {
                    sendingData: false,
                    submitted: false,
                    resultMessage: '',
                    succeeded: null
                },
                phrases: {
                    firstname: PhrasesService.shared.getPhrase('contact_firstname'),
                    lastname: PhrasesService.shared.getPhrase('contact_lastname'),
                    email: PhrasesService.shared.getPhrase('contact_email'),
                    phone: PhrasesService.shared.getPhrase('contact_phonenumber'),
                    message: PhrasesService.shared.getPhrase('contact_message'),

                    firstnameplaceholder: PhrasesService.shared.getPhrase('contact_firstnameplaceholder'),
                    lastnameplaceholder: PhrasesService.shared.getPhrase('contact_lastnameplaceholder'),
                    emailplaceholder: PhrasesService.shared.getPhrase('contact_emailplaceholder'),
                    phoneplaceholder: PhrasesService.shared.getPhrase('contact_phoneplaceholder'),
                    messageplaceholder: PhrasesService.shared.getPhrase('contact_messageplaceholder'),

                    send: PhrasesService.shared.getPhrase('contact_send'),
                    email: PhrasesService.shared.getPhrase('contact_email'),
                },
            };
        },
        methods: {
            send() {
                var _this = this;
                if (_this.settings.sendingData) { return; }
                _this.settings.submitted = true;
                _this.settings.resultMessage = '';

                if (!_this.userData.firstname.length || !_this.userData.lastname.length
                    || !_this.userData.email.length || !_this.userData.phone.length
                    || !_this.userData.message.length) {
                    return;
                }
                _this.settings.sendingData = true;

                axios.post(window._data.contactApiUrl + 'send',
                    {
                        firstname: _this.userData.firstname,
                        lastname: _this.userData.lastname,
                        email: _this.userData.email,
                        phone: _this.userData.phone,
                        message: _this.userData.message,
                        language: window._data.languageId
                    }).then(function (response) {
                        _this.settings.succeeded = response.data.succeeded;
                        _this.settings.resultMessage = response.data.message;
                        _this.settings.sendingData = false;
                    }).catch(function (e) {
                        _this.settings.sendingData = false;
                    }).finally(function (e) {
                        _this.settings.sendingData = false;
                    });
            },
            getFormClasses() {
                return {
                    'message-sent': !!this.settings.succeeded
                };
            }
        },
        mounted() {
        }
    ,
template: `
    <div class="message-form" :class="{'message-success' : settings.succeeded, 'message-error' : !settings.succeeded}">
        <!--message-success-->
        <div class="send-message-info container" v-show="settings.resultMessage.length">{{settings.resultMessage}}</div>
        <form class="message-form__wrapper container" :class="getFormClasses()">
            <div class="message-form__rows">
                <div class="message-form__input-box"
                     :class="{'has-error' : settings.submitted && !userData.firstname.length}">
                    <div class="input__wrapper">
                        <label class="input__label" for="">{{phrases.firstname}}</label>
                        <input class="input__type" :placeholder="phrases.firstnameplaceholder" type="text" id="" name=""
                               v-model="userData.firstname">
                    </div>
                </div>
                <div class="message-form__input-box"
                     :class="{'has-error' : settings.submitted && !userData.lastname.length}">
                    <div class="input__wrapper">
                        <label class="input__label" for="">{{phrases.lastname}}</label>
                        <input class="input__type" :placeholder="phrases.lastnameplaceholder" type="text" id="" name=""
                               v-model="userData.lastname">
                    </div>
                </div>
            </div>

            <div class="message-form__rows">
                <div class="message-form__input-box"
                     :class="{'has-error' : settings.submitted && !userData.email.length}">
                    <div class="input__wrapper">
                        <label class="input__label" for="">{{phrases.email}}</label>
                        <input class="input__type" :placeholder="phrases.emailplaceholder" type="email" id="" name=""
                               v-model="userData.email">
                    </div>
                </div>
                <div class="message-form__input-box"
                     :class="{'has-error' : settings.submitted && !userData.phone.length}">
                    <div class="input__wrapper">
                        <label class="input__label" for="">{{phrases.phone}}</label>
                        <input class="input__type" :placeholder="phrases.phoneplaceholder" type="number" id="" name=""
                               v-model="userData.phone">
                    </div>
                </div>
            </div>

            <div class="message-form__textarea-box"
                 :class="{'has-error' : settings.submitted && !userData.message.length}">
                <div class="text-area__wrapper">
                    <label class="text-area__label" for="">{{phrases.message}}</label>
                    <textarea class="text-area__text" :placeholder="phrases.messageplaceholder" id="message" name="message"
                              v-model="userData.message"></textarea>
                </div>
            </div>

            <div class="message-form__submit">
                <button class="button btn__with-arrow"
                        @click.prevent="send()"
                        :class="{'loading' : settings.sendingData}">
                    {{phrases.send}}
                    <svg class="btn__icon"><use xlink:href="~/m/i/icons.svg#arrow-right" /></svg>
                    <div class="spinner-border" role="status"></div>
                </button>
                <a class="message-form__email_link" href="">Email us: contact@aplaw.ge</a>
            </div>

        </form>

        <!--<div :class="{'general-message--success' : settings.succeeded, 'general-message--error' : !settings.succeeded}"
         v-show="settings.resultMessage.length">
        <p>{{settings.resultMessage}}</p>
    </div>-->
    </div>
`
});
Vue.component('svg-icon', {
        props: ['icon'],
        data: function () {
            return {
                baseUrl: window._data.baseUrl
            };
        },
        methods: {
            getIconUrl: function () {
                return this.baseUrl + 'm/i/icons.svg#' + this.icon;
            }
        },
        mounted() {
        }
    ,
template: `
    <svg v-once><use v-bind="{\'xlink:href\' : getIconUrl()}" /></svg>
`
});
(function (target) {

    target._app = new Vue({
        el: "#vueapp"
    });
})(window);
// headerf

$('.header__mobile-btn').click(function () {
    $('.header__ul').addClass('active');
    $('.header__burger-menu-color ').addClass('active');
});
$('.header__mobile-close-btn').click(function () {
  $('.header__ul').removeClass('active');
  $('.header__burger-menu-color ').removeClass('active');
});



// footer accordion 
$(".footer__accordion").on("click", ".footer__accordion-item", function () {
  $(this).toggleClass("active").next().slideToggle(100);
});

// main accordion 
$(".main__accordion").on("click", ".main__accordion-item", function () {
  const $next = $(this).next(".main__accordian-content-wrapper");
  $(".main__accordion-item").not(this).removeClass('active');
  $(".main__accordian-content-wrapper").not($next).removeClass('d-block');
  $(this).toggleClass("active");
  $next.toggleClass('d-block');
});

// comment slider swiper bundle
const swiperTestimonail = new Swiper('.comment__slider-container', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  autoHeight: true,
  // effect: 'fade',
  // Navigation arrows
  navigation: {
    nextEl: '.comment__next-arrow',
    prevEl: '.comment__prev-arrow',
  },
  // Navigation keyboard
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
});

// group slider swiper bundle
const swiperOurteam = new Swiper('.group__slider-container', {
  // Optional parameters
  slidesPerView: 2.5,
  spaceBetween: 15,
  direction: 'horizontal',
  loop: false,
  // Navigation arrows
  navigation: {
    nextEl: '.group__next-arrow',
    prevEl: '.group__prev-arrow',
  },
  // Navigation keyboard
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  breakpoints: {
    // before 991
    991: {
      spaceBetween: 40,
      slidesPerView: 3.2,
      // spaceBetweenSlides: 50,
    },
  }
});

// item-with-up-img slider swiper bundle
const swiperIndustries = new Swiper('.item-with-up-img__slider-container', {
  // Optional parameters
  slidesPerView: 1.2,
  spaceBetween: 20,
  direction: 'horizontal',
  loop: false,
  // Navigation arrows
  navigation: {
    nextEl: '.item-with-up-img__next-arrow',
    prevEl: '.item-with-up-img__prev-arrow',
  },
  // Navigation keyboard
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  breakpoints: {
    // before 991
    991: {
      slidesPerView: 3,
      spaceBetweenSlides: 50
    },
  }
});

// news slider swiper bundle
const swiperTodaysNews = new Swiper('.news__slider-container', {
  // Optional parameters
  slidesPerView: 1.2,
  spaceBetween: 20,
  direction: 'horizontal',
  loop: false,
  // Navigation arrows
  navigation: {
    nextEl: '.news__next-arrow',
    prevEl: '.news__prev-arrow',
  },
  // Navigation keyboard
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  breakpoints: {
    // before 991
    991: {
      slidesPerView: 2,
      spaceBetweenSlides: 50
    },
  }
});

// publications slider swiper bundle
const swiperPublications = new Swiper('.publications__slider-container', {
  // Optional \
  slidesPerView: 1,
  spaceBetween: 40,
  direction: 'horizontal',
  loop: false,
  // Navigation arrows
  navigation: {
    nextEl: '.publications__next-arrow',
    prevEl: '.publications__prev-arrow',
  },
  // Navigation keyboard
  keyboard: {
    enabled: true,
    onlyInViewport: false,
  },
  breakpoints: {
    // before 991
    991: {
      slidesPerView: 3,
      spaceBetweenSlides: 40
    },
  }
});

svg4everybody();